import { Component } from '@angular/core';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { INews } from 'src/app/interfaces/news';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { NewsService } from 'src/app/services/news.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false
})
export class NewsComponent {
     userProfileLoaded: boolean = false;
     userProfile?: UserProfile;
     username?: string;
     newsSet: INews[] = [];
     selectedLanguage: string = 'en';
     translatedArticles: INews[] = [];
     previewItemId?: string;
     previewParentItemId: string = '';

     constructor(public generalService: GeneralService,
          public authenticationService: AuthenticationService, 
          public translatorService: TranslatorService, 
          public newsService: NewsService, 
          private router: Router) {
          var params = this.generalService.getQueryParameters(this.router.url);
          if (params && params['previewItemId']) {
               this.previewItemId = params['previewItemId']
               if (params && params['previewParentItemId']) {
                    this.previewParentItemId = params['previewParentItemId']
               }     
          }
     }

     ngOnInit(): void {
          this.userProfile = this.authenticationService.getUserProfile();
          this.username = this.authenticationService.getUserName();
          this.selectedLanguage = this.translatorService.getActiveLanguage().toLocaleUpperCase();

          let newsPromise:any;
          if (this.previewItemId) {
               newsPromise = this.newsService.getNewsForPreview(this.previewItemId, this.previewParentItemId);
          } else {
               newsPromise = this.newsService.getNews();
          }
           
          newsPromise.subscribe((result: any) => this.showNews(result));
     }

     showNews(results: any[]) {
          this.userProfileLoaded = true;
          if (results && results[0] === 'true') {
               this.newsSet = this.newsService.newsSet;
               this.translatedArticles = this.newsSet;
          } else {
               this.newsSet = [];
          }
     }

     getTitle(item: INews){
          this.selectedLanguage = this.translatorService.getActiveLanguage().toLocaleUpperCase();
          if (this.selectedLanguage === 'FR') {
               return item.title_FR;
          } else if (this.selectedLanguage === 'ES') {
               return item.title_ES;
          }else{
               return item.title;
          }
     }

     getBody(item: INews){
          this.selectedLanguage = this.translatorService.getActiveLanguage().toLocaleUpperCase();
          if (this.selectedLanguage === 'FR') {
               return  item.body_FR;
          } else if (this.selectedLanguage === 'ES') {
               return  item.body_ES;
          }else{
               return item.body;
          }
     }
}